// Toont een duidelijke banner wanneer de app als STAGING-build is gebouwd.
// De vlag REACT_APP_ENV=staging wordt door deploy-staging.sh bij de build gezet;
// productie bouwt zonder die vlag, dus daar verschijnt niets.
const IS_STAGING = process.env.REACT_APP_ENV === 'staging';

export default function StagingBanner() {
  if (!IS_STAGING) return null;
  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        background:
          'repeating-linear-gradient(45deg,#b45309,#b45309 14px,#92400e 14px,#92400e 28px)',
        color: '#fff',
        textAlign: 'center',
        fontWeight: 700,
        letterSpacing: '0.4px',
        padding: '5px 10px',
        fontSize: '13px',
        boxShadow: '0 1px 4px rgba(0,0,0,.25)',
      }}
    >
      ⚠ STAGING — testomgeving (geen productiedata)
    </div>
  );
}
